import { createContext } from 'react';

import type { ToastDispatcher, ToastObj } from '../types';

export interface ToastContextValue {
  /** Open a toast alert. The alert is dismissed after a timeout. */
  openToast: ToastDispatcher;
  /** The toast that is currently open. */
  toast: ToastObj | undefined;
  /** Close the toast alert. */
  closeToast: () => void;
}

/** This context is used by the {@link useToast} hook. */
export const ToastContext = createContext<ToastContextValue>({
  openToast: () => undefined,
  closeToast: () => undefined,
  toast: undefined,
});
